<div>
  <app-visible-fee-filters
    (search)="searchData($event)">
  </app-visible-fee-filters>
  <mat-divider></mat-divider>
  <app-visible-fee-map-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [data]="data"
    [responseType]="responseType">
  </app-visible-fee-map-chart>
</div>
